import { formatRoleStringForDisplay } from "./rbacExternalAdmin";

export const roleRenamer = (role: string) => {
  if (!role) return role;
  if (role.toLowerCase().startsWith("custom_")) {
    return formatRoleStringForDisplay(role);
  }
  const displayRole =
    role === "subadmin"
      ? "Masjid Admin"
      : role === "admin"
      ? "Data Entry"
      : role === "superadmin"
      ? "Super Admin"
      : role === "musaliadmin"
      ? "Musali Admin"
      : role;
  return displayRole.charAt(0).toUpperCase() + displayRole.slice(1);
};
